<section class="p-3">
	<div class="d-flex flex-row mb-2">
		<mat-form-field appearance="outline" class="custom-form-field">
			<input
				matInput
				placeholder="Filtrowanie (min. 3 znaki)"
				[(ngModel)]="filterValue"
				(keyup)="refreshFilter()"
			/>
		</mat-form-field>
		<button mat-raised-button class="mat-custom-raised" color="yellow" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
	<mat-table
		#dataTable
		id="mat-table"
		[dataSource]="matData"
		matSort
		matSortDirection="asc"
		class="mat-elevation-z4 sizeTable"
	>
		<ng-container *ngFor="let item of columns" [matColumnDef]="item.col">
			<mat-header-cell
				class="custom-header"
				*matHeaderCellDef
				mat-sort-header
				[style.maxWidth]="[item?.size] + 'px'"
			>
				{{ item.header }}
			</mat-header-cell>
			<mat-cell *matCellDef="let element" [style.maxWidth]="[item?.size] + 'px'">
				<span *ngIf="!isArray(element[item.col]) && !element[item.col]?.isLink && !item?.longText">{{
					element[item.col]
				}}</span
				><a [href]="element[item.col]?.route" *ngIf="element[item.col]?.isLink" target="_blank">{{
					element[item.col].label
				}}</a>
				<abbr *ngIf="item?.longText && element[item.col]?.length > 32" title="{{ element[item.col] }}"
					>{{ element[item.col].substring(0, 29) }}...
				</abbr>
				<span *ngIf="item?.longText && element[item.col]?.length < 32">
					{{ element[item.col] }}
				</span>
				<span *ngIf="isArray(element[item.col])"
					><span *ngFor="let obj of removeDuplicates(element[item.col]).slice(0, 1)"
						>{{ obj
						}}<span class="my-2"
							><button
								class="mat-custom-editButton mx-2 my-2"
								mat-raised-button
								*ngIf="removeDuplicates(element[item.col]).length - 1 > 0"
								matTooltip="{{ removeDuplicates(element[item.col]).slice(1) }} "
							>
								+
								{{ removeDuplicates(element[item.col]).length - 1 }}
							</button></span
						></span
					></span
				>
				<a [routerLink]="element[item.col]?.route" *ngIf="element[item.col]?.isLink" target="_blank">{{
					element[item.col].label
				}}</a>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="columnShow">
			<mat-header-cell *matHeaderCellDef
				><button mat-icon-button [matMenuTriggerFor]="option">
					<mat-icon><i class="fa-solid fa-ellipsis-vertical"></i></mat-icon>
				</button>
				<mat-menu class="custom-mat-menu" #option="matMenu">
					<button mat-menu-item (click)="openDialog()">Widok kolumn<i class="fas fa-eye ms-2"></i></button>
				</mat-menu>
			</mat-header-cell>
			<mat-cell *matCellDef="let element" class="justify-content-center">
				<a *ngIf="haveLink" class="mat-custom-editButton" [routerLink]="element.link" mat-raised-button> >> </a>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="showColumns" class="mat-header-custom"></mat-header-row>
		<mat-row *matRowDef="let row; columns: showColumns; let i = index" [ngClass]="{ second: !(i % 2) }"></mat-row>
	</mat-table>

	<div id="no-results" class="mat-elevation-z4 py-5 text-center sizeTable" *ngIf="!matData.data.length">
		Brak wyników
	</div>

	<mat-paginator
		class="mat-elevation-z4 custom-left-mat-paginator"
		id="mat-paginator"
		[pageSizeOptions]="pageSizeOptions"
		showFirstLastButtons
	>
	</mat-paginator>
</section>
